import {
  LOG_SET_CURRENT_FILTERS,
  LOG_SET_PAGINATION,
  LOG_SET_LOGS,
  LOG_GET_DYNAMIQUE_FILTER_VALUES,
  LOG_SET_SORT,
  LOG_SET_KEY_FILTER_SELECTED
} from "../types";

function action(type, payload = {}) {
  return { type, ...payload };
}

export const setLogs = logs => action(LOG_SET_LOGS, logs);

export const init = () => {
  return (dispatch, getState) => {
    const state = getState();
    dispatch(setPagination(1, state.log.pages));
  };
};

export const getLogs = data => {
  return (dispatch, getState) => {
    const state = getState();
    dispatch(setPagination(data.page, state.log.pages));
  };
};

export const setSort = (columnKey, sortOrder) => {
  return action(LOG_SET_SORT, columnKey, sortOrder);
};

export const setPagination = (page, pages) => ({
  type: LOG_SET_PAGINATION,
  page,
  pages
});

export const setCurrentFilters = currentFilters => ({
  type: LOG_SET_CURRENT_FILTERS,
  currentFilters
});

export function updateFiltersDate(key, filters) {
  return (dispatch, getState) => {
    const state = getState();

    const currentFilters = state.log.currentFilters || {};

    if (filters) {
      currentFilters[key] = filters;
    } else {
      delete currentFilters["sector_label"]; // Remove current filters when date is unselected
      delete currentFilters["retailer_label"];
      delete currentFilters["pdc_label"];
      delete currentFilters["startDate"];
      delete currentFilters["endDate"];
    }
    dispatch(setCurrentFilters(currentFilters));
    dispatch(getLogs({ filters: currentFilters, page: 1 }));
  };
}

export function updateFiltersFront(key, filters) {
  return (dispatch, getState) => {
    const state = getState();
    const currentFilters = state.log.currentFilters || {};
    if (filters && (filters.length && filters.length !== 0)) {
      currentFilters[key] = filters;
    } else {
      delete currentFilters[key];
    }
    if (key === "surveyId") {
      delete currentFilters["sector_label"]; // Remove current filters when surveyId is unselected
      delete currentFilters["retailer_label"];
      delete currentFilters["pdc_label"];
    }

    dispatch(setCurrentFilters(currentFilters));
    dispatch(getLogs({ filters: currentFilters, page: 1 }));
  };
}
export const setKeyFilterSelected = key => ({
  type: LOG_SET_KEY_FILTER_SELECTED,
  key
});
export function getDynFilterValues(key) {
  return action(LOG_GET_DYNAMIQUE_FILTER_VALUES, key);
}



// WEBPACK FOOTER //
// src/redux/actions/logActions.js